module.exports = __webpack_public_path__ + "static/media/Guido Marsan  (2).260f7b6e.jpg";